import styled, { css } from "styled-components";
import { DesignTokens, Tooltip } from "melco-ui";
import { StatusInfo } from "./item/StatusInfo";
import { WarningBadge } from "./item/WarningBadge";
import { MachineName } from "./item/MachineName";
import { useTranslation } from "react-i18next";
import { backgroundColorLookup } from "../../helper/reportingHelper";
import { isEmpty } from "lodash-es";

const { spacings, colors, elevations } = DesignTokens;

const MACHINE_STATUS_ITEM_BORDER_RADIUS = 5;

const MACHINE_STATUS_COLOR_DEFAULT = colors.gray.superLight;

const Item = styled.div.withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
}) <Pick<MachineStatusGridItemProps, "status">>`
  cursor: default;
  display: flex;
  position: relative;
  background-color: ${MACHINE_STATUS_COLOR_DEFAULT};
  border-radius: ${MACHINE_STATUS_ITEM_BORDER_RADIUS}px;
  padding: ${spacings.middle}px;
  min-width: 0; //Prevent from grid blowout

  ${({ status }) => {
    const backgroundColor = backgroundColorLookup[status.bgColorId];

    if (!isEmpty(backgroundColor)) {
      return css`
        && {
          background-color: ${backgroundColor};
          z-index: ${elevations.level1.zIndex};

          &:hover {
            animation-play-state: paused;
          }
        }
      `;
    }
  }}
`;

type MachineStatusGridItemProps = {
  machineName: string;
  status: any;
  tooltip?: string;
  isActive: boolean;
  onToggle: (machineName: string) => void;
  keyForTooltip: string;
};

export const MachineStatusGridItem: React.FC<MachineStatusGridItemProps> = ({
  machineName,
  status,
  tooltip,
  isActive,
  onToggle,
  keyForTooltip,
}) => {
  const { t } = useTranslation();

  // const [visibleTooltipIndex, setVisibleTooltipIndex] = useState<string | null>(
  //   null
  // ); // Track which div's tooltip is visible

  const item = (
    <Item status={status}>
      <MachineName status={status} name={machineName} />
      <StatusInfo status={status} />
      {status?.textId === "notconnected" && <WarningBadge />}
    </Item>
  );

  // const handleClick = (index: string) => {
  //   // Toggle the tooltip for the clicked div
  //   setVisibleTooltipIndex((prevIndex) => (prevIndex === index ? null : index));
  // };

  if (tooltip) {
    return (
      <Tooltip
        key={machineName}
        title={
          <>
            <strong>{t("view.tooltip.title")}</strong>
            <div>{tooltip}</div>
          </>
        }
        // visible={visibleTooltipIndex === machineName}
        visible={isActive}
        placement="top"
      >
        {/* <div onClick={() => handleClick(machineName)}>{item}</div> */}
        <div onClick={() => onToggle(keyForTooltip)}>{item}</div>
      </Tooltip>
    );
  }

  return item;
};
